.ja{pointer-events:auto;}